module.exports = __webpack_public_path__ + "img/0f734239-5468-4683-bade-c4347f0014c9.40f32b55.jpg";